import MyAccount from "@/pages/MyAccount";
import { Grid, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import DisplayRejectReason from "../ViewOnboardingDocuments/DisplayRejectReason";
import OnboardingInputFields, {
  enumFields,
  InputFields,
} from "../ViewOnboardingDocuments/OnboardingInputFeilds";
import { OnboardingDocumentMasterType } from "@/constants/enums/onboarding-document-master-types.enum";
import { UserTierType } from "@/constants/enums/user-tier-type.enum";
import { AppDispatch, RootState } from "@/store";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import actionsHandler from "@/store/actions/actionHandler";
import DisplaySopDetails, {
  SopData,
} from "../ViewOnboardingDocuments/DisplaySopDetails";
import CheckWhiteIcon from "@styles/all-images/icons/checkwhite.svg";
import CloseBlueIcon from "@styles/all-images/icons/closeblue.svg";
import CloseRedIcon from "@styles/all-images/icons/closered.svg";
import ApprovedIcon from "@styles/all-images/icons/checkgreen.svg";
import { DocumentApprovalStatus } from "@/constants/enums/document-approval-status.enum";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import TierConfigurationRejectionReason from "@pages/TierConfiguration/TierConfigurationRejectionReason";
import ViewTimeLineDocument from "@/pages/T4/T4OnBoardingDocument/TimeLineOnBoardingDocumnet/ViewTimeLineDocument";
import { Document } from "../../DocumentMasterTab";
import { TimelineData } from "../TimeLineOnBoardingDocumnet/ViewTimeLineDocument";
import ChatIconBlue from "@styles/all-images/icons/ChatIconBlue.svg";
import StandaloneChatDrawer, {
  StandaloneChatDrawerType,
} from "@/pages/LiveChat/StandaloneChatDrawer";
import { DocumentInfo } from "@/pages/LiveChat/StandaloneChatDrawer/ChatComponent";
interface CommodityType {
  id: number;
  title: string;
}

interface FinOb1ViewProps {
  userId?: string;
  description?: string;
  status?: DocumentApprovalStatus | null;
  isTimeline?: boolean;
  documents?: Document[];
  forceRefresh?: boolean;
  setForceRefresh?: (forceRefresh: boolean) => void;
}

interface FinOb1Details {
  [key: string]: any;
}

const FinOb1View = React.memo(
  ({
    userId,
    description,
    status,
    isTimeline = false,
    documents,
    forceRefresh,
    setForceRefresh,
  }: FinOb1ViewProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [finOb1Details, setFinOb1Details] = useState<FinOb1Details>({});
    const [isLoading, setIsLoading] = useState(false);
    const user = useSelector((state: RootState) => state.auth.user);
    const { id: userParamId } = useParams();
    const { authenticatedCall: fetchFinOb1Details } = actionsHandler(
      "viewOnboardingDocumentFinOb1InputFields",
    );
    const { authenticatedCall: fetchCommodities } =
      actionsHandler("commodityList");
    const [commodityList, setCommodityList] = useState<CommodityType[]>([]);
    const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
    const navigate = useNavigate();
    const [timelineData, setTimelineData] = useState<
      Record<string, TimelineData[]>
    >({});
    const [isTimelineLoading, setIsTimelineLoading] = useState(false);
    const [documentChatUserId, setDocumentChatUserId] = useState<number | null>(
      null,
    );
    const [documentChatDocumentInfo, setDocumentChatDocumentInfo] =
      useState<DocumentInfo | null>(null);
    const [documentChatRoomId, setDocumentChatRoomId] = useState<string | null>(
      null,
    );
    const [isDocumentChatOpen, setIsDocumentChatOpen] = useState(false);
    const [isFormValid, setIsFormValid] = useState(true);

    const getFinOb1Details = async () => {
      try {
        setIsLoading(true);
        const response = await dispatch(
          fetchFinOb1Details({
            method: "get",
            customParams: [`${userId || user?.id}/`],
          }),
        );
        if (response.ok) {
          const initialValues = {
            ...response.data.data,
            commodity_types: response.data.data?.commodity_types?.id,
          };
          setFinOb1Details(initialValues);
          checkFormValidity(initialValues);
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    const getCommodityList = async () => {
      try {
        const response = await dispatch(
          fetchCommodities({
            method: "get",
          }),
        );
        if (response.ok) {
          setCommodityList(response.data);
        }
      } catch (error) {}
    };
    const checkFormValidity = (data: FinOb1Details) => {
      const inputFields =
        [...enumFields[OnboardingDocumentMasterType.finOb1]] || [];
      if (inputFields && inputFields.length > 0) {
        const requiredField = inputFields?.find((field: any) => field.required);
        const isInputRequiredValueAvailable =
          !requiredField || data?.[requiredField?.name as keyof InputFields]
            ? true
            : false;
        if (isInputRequiredValueAvailable) {
          setIsFormValid(true);
        } else {
          setIsFormValid(false);
        }
      }
    };
    const getFinOb1Timeline = async () => {
      try {
        setIsTimelineLoading(true);
        const { authenticatedCall: fetchFinOb1Timeline } =
          actionsHandler("finOb1Timeline");
        const response = await dispatch(
          fetchFinOb1Timeline({
            method: "get",
            customParams: [`${documents?.[0]?.uploaded_document?.id}/`],
          }),
        );

        if (response.ok) {
          const transformedData: Record<string, TimelineData[]> = {
            [userId || user?.id]: response.data.data,
          };
          setTimelineData(transformedData);
        }
      } catch (error) {
      } finally {
        setIsTimelineLoading(false);
      }
    };

    useEffect(() => {
      if (isTimeline) {
        getFinOb1Timeline();
      } else {
        getFinOb1Details();
        getCommodityList();
      }
    }, [userId, isTimeline]);

    const handleRejectSubmit = async (rejectionReason: string) => {
      try {
        setIsLoading(true);
        const { authenticatedCall } = actionsHandler("documentApproval");
        const response = await dispatch(
          authenticatedCall({
            method: "post",
            payload: {
              document_id: documents?.[0]?.uploaded_document?.id,
              status: 3, // 2 for reject
              note: rejectionReason,
            },
          }),
        );

        if (response.ok) {
          toast.success(response.data.message);
        }
        setIsRejectionModalOpen(false);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    const handleApprove = async () => {
      try {
        setIsLoading(true);
        const { authenticatedCall } = actionsHandler("documentApproval");
        const response = await dispatch(
          authenticatedCall({
            method: "post",
            payload: {
              document_id: documents?.[0]?.uploaded_document?.id,
              status: 2, // 1 for approve
            },
          }),
        );

        if (response.ok) {
          toast.success(response.data.message);
          setForceRefresh?.(true);
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    const handleChat = (document: Document) => {
      if (document.uploaded_document.id) {
        const userId =
          user?.user_type?.id === UserTierType.Tier4 ? user?.id : userParamId;
        setDocumentChatUserId(userId);
        setDocumentChatDocumentInfo({
          id: document.uploaded_document.id,
          title: document.document_name,
          status: document.uploaded_document.status,
        });
        setDocumentChatRoomId(document.uploaded_document.room_id?.toString());
        setIsDocumentChatOpen(true);
      } else {
        toast.warning("Chat is not available for this document");
      }
    };

    if (isTimeline) {
      return (
        <>
          <div className="tw-bg-white tw-pb-3 tw-rounded-lg">
            <h2 className="tw-text-md tw-font-semibold">{description}</h2>
          </div>
          {isTimelineLoading ? (
            <div className="tw-flex tw-justify-center tw-items-center">
              <CircularProgress />
            </div>
          ) : (
            <ViewTimeLineDocument
              timelineData={timelineData}
              skipFetch={true}
            />
          )}
        </>
      );
    }

    return (
      <>
        <div className="tw-bg-white tw-pb-3 tw-rounded-lg tw-flex tw-justify-between tw-items-center">
          <h2 className="tw-text-md tw-font-semibold">{description}</h2>
          <div>
            <div className="tw-flex tw-space-x-4 tw-mt-4">
              <button
                onClick={() => documents?.[0] && handleChat(documents?.[0])}
                className="tw-relative"
              >
                <img
                  src={ChatIconBlue}
                  alt="Download Icon"
                  className="tw-w-10 tw-h-10 tw-max-w-10 tw-max-h-10 tw-min-w-10 tw-min-h-10"
                />
                {Boolean(
                  documents?.[0]?.uploaded_document?.un_read_count &&
                    documents?.[0]?.uploaded_document?.un_read_count > 0,
                ) && (
                  <span className="tw-absolute tw-top-[0px] tw-right-[0px] tw-bg-[#146C94] tw-text-white tw-rounded-full tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-text-xs">
                    {documents?.[0]?.uploaded_document?.un_read_count}
                  </span>
                )}
              </button>

              {user?.user_type?.id === UserTierType.Tier3 &&
                status === DocumentApprovalStatus.pending &&
                !isLoading && (
                  <>
                    <button
                      onClick={() => setIsRejectionModalOpen(true)}
                      className="tw-flex-1 tw-px-4 tw-py-2 tw-border tw-flex tw-items-center tw-justify-center tw-gap-2 tw-font-semibold tw-border-[#146C94] tw-rounded-lg tw-text-[#146C94]"
                      disabled={isLoading}
                    >
                      Reject
                      <img
                        src={CloseBlueIcon}
                        alt="Close Icon"
                        className="tw-w-6 tw-h-6 tw-min-w-6 tw-min-h-6 tw-max-w-6 tw-max-h-6"
                      />
                    </button>
                    <button
                      onClick={handleApprove}
                      className={`tw-bg-[#146C94] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-font-semibold tw-text-white tw-rounded-lg tw-px-4 tw-py-2 tw-flex-1 ${
                        !isFormValid
                          ? "tw-opacity-50 tw-cursor-not-allowed"
                          : ""
                      }`}
                      disabled={!isFormValid || isLoading}
                    >
                      {"Approve"}
                      <img
                        src={CheckWhiteIcon}
                        alt="Check Icon"
                        className="tw-w-6 tw-h-6 tw-min-w-6 tw-min-h-6 tw-max-w-6 tw-max-h-6"
                      />
                    </button>
                  </>
                )}
            </div>
          </div>
        </div>
        <Grid container>
          <Grid item xs={12} md={3}>
            <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-4">
              <DisplaySopDetails title="SOP" items={finOb1Details?.sop} />

              <DisplayRejectReason
                rejectedBy={null}
                reason={documents?.[0]?.uploaded_document?.note}
                updatedAt={documents?.[0]?.uploaded_document?.updated_at}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <MyAccount userId={userId || user?.id} isCustomView={true} />
          </Grid>
          <Grid item xs={12} md={3}>
            <div className="tw-mt-4">
              {isLoading ? (
                <div className="tw-flex tw-justify-center tw-items-center">
                  <CircularProgress />
                </div>
              ) : (
                <div className="tw-flex tw-flex-col tw-gap-4">
                  {!isLoading && (
                    <OnboardingInputFields
                      document_master={OnboardingDocumentMasterType.finOb1}
                      input_fields={finOb1Details}
                      inputFieldCustomOptions={{
                        commodity_types: commodityList.map((commodity) => ({
                          id: commodity.id,
                          label: commodity.title,
                          value: commodity.id,
                        })),
                      }}
                      readOnly={
                        user?.user_type?.id !== 3 ||
                        status !== DocumentApprovalStatus.pending
                      }
                      isFinOb1={true}
                      user_id={userId || user?.id}
                      onSave={() => {
                        setForceRefresh?.(true);
                        getFinOb1Details();
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </Grid>
        </Grid>
        {isRejectionModalOpen && (
          <TierConfigurationRejectionReason
            onClose={() => setIsRejectionModalOpen(false)}
            onSubmit={handleRejectSubmit}
            isLoading={isLoading}
          />
        )}

        {documentChatUserId && (
          <StandaloneChatDrawer
            isChatNotificationOpen={isDocumentChatOpen}
            setIsChatNotificationOpen={setIsDocumentChatOpen}
            documentInfo={documentChatDocumentInfo || undefined}
            documentId={documentChatDocumentInfo?.id || undefined}
            userId={documentChatUserId}
            customChatRoomId={documentChatRoomId}
            type={StandaloneChatDrawerType.DOCUMENT}
          />
        )}
      </>
    );
  },
);

FinOb1View.displayName = "FinOb1View";
export default FinOb1View;
